const MainMenu = {

    // FIELDS
    "name": "Pangalan",
    "description": "Paglalarawan",
    "menu_icon": "Icon",
    "status": "Katayuan",
    "priority": "Prayoridad",
    "search": "Maghanap",

    // PAGE HEADER
    "main_menu": "Pangunahing Menu",

    // ERROR
    "error_name": "Ilagay ang Pangalan",
    "error_desc": "Ilagay ang Paglalarawan",
    "error_status": "Piliin ang Katayuan",
    "error_priority_positive": "Dapat Maging Positibo ang Prayoridad",
    "error_priority_required": "Ilagay ang Prayoridad",
    "error_priority_type_error": "Maglagay lamang ng Numero",
    "error_icon": "Ilagay ang Pangalan ng Icon",

    // TABLE HEADER
    "table_name": "PANGALAN",
    "table_description": "PAGLALARAWAN",
    "table_priority": "PRAYORIDAD",
    "table_status": "KATAYUAN",

}

export default MainMenu;